// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ShareMarketingProfileDialog = require("./ShareMarketingProfileDialog.bs.js");
let UnifiedProfilePublicActions_account_graphql = require("../../__generated__/UnifiedProfilePublicActions_account_graphql.bs.js");

let convertFragment = UnifiedProfilePublicActions_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedProfilePublicActions_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedProfilePublicActions_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedProfilePublicActions_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedProfilePublicActions_account_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedProfilePublicActions(props) {
  let __viewLabel = props.viewLabel;
  let viewLabel = __viewLabel !== undefined ? __viewLabel : "View Profile";
  let account = RescriptRelay_Fragment.useFragment(UnifiedProfilePublicActions_account_graphql.node, convertFragment, props.account);
  let match = React.useState(() => false);
  let setShareOpen = match[1];
  let profile = account.profile;
  let match$1;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      match$1 = [
        profile.publicUrl,
        Stdlib_Option.map(profile.urlDetails, details => details.fragmentRefs)
      ];
      break;
    case "TeamAccountProfile" :
      match$1 = [
        profile.publicUrl,
        Stdlib_Option.map(profile.urlDetails, details => details.fragmentRefs)
      ];
      break;
    case "__unselected" :
      match$1 = UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
      break;
  }
  let publicUrl = match$1[0];
  if (publicUrl === undefined) {
    return null;
  }
  let publicUrl$1 = Primitive_option.valFromOption(publicUrl);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
        href: Scalars.URL.toString(publicUrl$1),
        target: "_blank",
        size: "small",
        children: viewLabel
      }),
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => setShareOpen(param => true),
        size: "small",
        _type: "button",
        children: "Share"
      }),
      JsxRuntime.jsx(ShareMarketingProfileDialog.make, {
        publicUrl: publicUrl$1,
        urlDetails: match$1[1],
        isOpen: match[0],
        onDismiss: () => setShareOpen(param => false)
      })
    ],
    className: "flex flex-wrap items-center gap-3"
  });
}

let make = UnifiedProfilePublicActions;

exports.Fragment = Fragment;
exports.make = make;
/* react Not a pure module */
